import { css } from 'lit';
export const UploaderDisplayCss = css `
    .uploader-container {
        position: relative;
        width: 100%;
        max-width: 450px;
        margin: 0 auto;
        padding: 40px 20px;
        box-sizing: border-box;
        border: 2px dashed #ccd0d5;
        border-radius: 12px;
        background-color: #f7f8fa;
        color: #606770;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        overflow: hidden;
        font-family: inherit;
    }
    
    .uploader-container.dragging-over,
    .uploader-container:hover {
        border-color: #3b82f6;
        background-color: #eff6ff; 
    }

    .content-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .uploader-container .icon {
        width: 64px;
        height: 64px;
        margin-bottom: 16px;
        color: #1877f2;
    }
    .prompt {
        font-weight: 600;
        font-size: 1.1rem;
        margin-bottom: 8px;
        color: #1c1e21;
    }
    .support-text {
        font-size: 0.9rem;
    }
    .uploader-container .loader {
        border: 5px solid #f3f3f3;
        border-top: 5px solid #1877f2;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 1s linear infinite;
        margin-bottom: 16px;
    }
    .success-icon, .error-icon {
        width: 64px;
        height: 64px;
        margin-bottom: 16px;
        stroke-width: 1.5;
    }
    .success-icon { color: #31a24c; }
    .error-icon { color: #fa383e; }
    
    .file-name {
        font-weight: 500;
        word-break: break-all;
        font-size: 0.9rem;
        color: #606770;
        margin-top: 4px;
    }
    .error-message {
        color: #fa383e;
        font-size: 0.9rem;
        margin-top: 8px;
        word-break: break-word;
    }
    .try-again-button {
        margin-top: 16px;
        padding: 8px 16px;
        border: none;
        background-color: #1877f2;
        color: white;
        border-radius: 6px;
        cursor: pointer;
        font-weight: 600;
    }
`;
